import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

import { COLOR_FONT_0 } from '../../colors';

/* eslint-disable max-statements */
export class ChordDiagram extends Component {
  /**
   *
   */
  componentDidMount() {
    const { chartId, data } = this.props;

    am4core.options.queue = true;
    am4core.options.onlyShowOnViewport = true;

    const chart = am4core.create(chartId, am4charts.ChordDiagram);
    chart.data = data;

    chart.dataFields.fromName = 'from';
    chart.dataFields.toName = 'to';
    chart.dataFields.value = 'value';

    const { label } = chart.nodes.template;
    label.fontSize = 10;
    label.fontFamily = 'Raleway';
    label.fontWeight = 300;
    label.fill = am4core.color(COLOR_FONT_0);
    label.relativeRotation = 90;

    this.chart = chart;
  }

  /**
   *
   */
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  /**
   *
   */
  render() {
    return <div id={this.props.chartId} style={{ width: '100%', height: '512px' }} />;
  }
}

ChordDiagram.propTypes = {
  chartId: PropTypes.string.isRequired
  // data:
};
